import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import CampSessionApi from './CampSessionApi';
import CampSessionActions from './Components/CampSessionActions';

let settings;

export default settings = {
    key: 'camp/sessions',
    zone: 'camp',
    path: '/camp/sessions',
    title: "Camp Sessions",
    endpoint: CampSessionApi.endpoint,
    modelName: 'CampSession',
    idKey: 'id',
    primaryKey: 'title',
    indexCaps: ["viewCampSession"],
    viewCaps: ["viewCampSession"],
    createCaps: ["createCampSession"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);



        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path
            },
            {
                label: "Published",
                path: settings.path + "/status/publish",
            },
            {
                label: "Cancelled",
                path: settings.path + "/status/cancelled",
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: CampSessionApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['operator', 'sessionGroup', 'host'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['title', 'venue'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Title",
                key: "title",
                type: "text",
            },
            {
                label: "Date & Time",
                key: "dateTime",
                type: "date"
            },
            {
                label: "Operator",
                key: "operatorId",
                type: "relationship",
                model: "CampOperator",
            },
            {
                label: "Host",
                key: "hostId",
                type: "relationship",
                model: "Hosts",
            },
            {
                label: "Session Group",
                key: "sessionGroupId",
                type: "relationship",
                model: "CampSessionGroup",
            },
            {
                label: "Status",
                key: "status",
                type: "choice",
                options: [
                    { value: "draft", label: "Draft" },
                    { value: "preview", label: "Preview" },
                    { value: "publish", label: "Publish" },
                    { value: "archive", label: "Archive" },
                ],
            },
            {
                label: "Attendees",
                key: "attendeeCount",
                type: "number",
            }
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Title",
                key: "this",
                format: "ModelLink"
            },
            {
                label: "Date & Time",
                key: "dateTime",
                format: "dateTime"
            },
            {
                label: "Status",
                key: "status",
                format: "titleCase"
            },
            {
                label: "Host",
                key: "host",
                format: "ModelLink"
            },
            {
                label: "Operator",
                key: "operator",
                format: "ModelLink",
            },
            {
                label: "Session Group",
                key: "sessionGroup",
                format: "ModelLink",
            },
            {
                label: "Duration",
                key: "duration"
            },
            {
                label: "Venue",
                key: "venue"
            },
            {
                label: "Attendees",
                key: "attendeeCount",
                format: "number"
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                render: (value, data) => {

                    return <CampSessionActions data={data} />;

                }
            }
        ];

        return columns;

    },

    indexExportFormats: (routeName, params, user) => {

        const formats = [
            { value: "campSessions", label: "Camp Sessions" }
        ];

        return formats;

    },

    singleFetch: CampSessionApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters: any = { include: [] };

        if (routeName === settings.key + "View") filters.include = ['operator', 'sessionGroup', 'host'];

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit"
            },
        ]

    },
};